import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { UiBsCashInModule } from '@wlp/ui-bs-cashin';
import { UiBsCashOutModule } from '@wlp/ui-bs-cashout';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCAccountBalanceModule } from '@wlp/ui-c-account-balance';
import { UiCAsideMenuLeftModule } from '@wlp/ui-c-aside-menu-left';
import { UiCCardInfoModule } from '@wlp/ui-c-card-info';
import { UiCDatePickerModule } from '@wlp/ui-c-date-picker';
import { UiCEmitBilletChargingModule } from '@wlp/ui-c-emit-billet-charging';
import { UiCEmitBilletChargingV1Module } from '@wlp/ui-c-emit-billet-charging-v1';
import { UiCFavoritesListModule } from '@wlp/ui-c-favorites-list';
import { HeaderUserInfoModule } from '@wlp/ui-c-header-user-info';
import { UiCInfoCardModule } from '@wlp/ui-c-info-card';
import { UiCModalModule } from '@wlp/ui-c-modal';
import { UiCNotificationsModule } from '@wlp/ui-c-notifications';
import { UiCOtherAccountModule } from '@wlp/ui-c-other-account';
import { UiCPersonalAddressModule } from '@wlp/ui-c-personal-address';
import { UiCPersonalAddressV2Module } from '@wlp/ui-c-personal-address-v2';
import { UiCTransferReceiptModule } from '@wlp/ui-c-transfer-receipt';
import { UiCTransferValueModule } from '@wlp/ui-c-transfer-value';
import { UiCInputModule } from '@wlp/ui-c-input';
import { BrMaskerModule } from 'br-mask';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { ComponentsModule } from 'src/app/core/shared/modules/components.module';
import { environment } from 'src/environments/environment';

import { InterceptService } from '../../../../../../../core/intercept/intercept.service';
import { ModalFavoriteTypeComponent } from '../../../../modals/modal-favorite-type/modal-favorite-type.component';
import { ModalImportBilletModelComponent } from '../../../../modals/modal-import-billet-model/modal-import-billet-model.component';
import { ModalTransferOnUsComponent } from '../../../../modals/modal-transfer-on-us/modal-transfer-on-us.component';
import { ModalsModule } from '../../../../modals/modals.module';
import { CharginBilletCreatePage } from './billet/billet-create/billet-create.page';
import { CharginBilletEmitPage } from './billet/billet-emit/billet-emit.page';
import { CharginBilletEmitConfirmation } from './billet/billet-emit-confirmation/billet-emit-confirmation.page';
import { CharginBilletViewDetail } from './billet/billet-view-detail/billet-view-detail.page';
import { CharginBilletDetailedPage } from './billet/billet-emit-detailed/billet-emit-detailed.page';
import { CharginBilletEdit } from './billet/billet-edit/billet-edit.page';
import { BilletInfo } from './billet/billet-edit/billet-info/billet-info';
import { FormDueDate } from './billet/billet-edit/forms/form-due-date/form-due-date';
import { FormEmitBilletDetails } from './billet/components/form-emit-billet-details/form-emit-billet-details';
import { FormDeadlinePayment } from './billet/billet-edit/forms/form-deadline-payment/form-deadline-payment';
import { FormNominalValue } from './billet/billet-edit/forms/form-nominal-value/form-nominal-value';
import { FormFees } from './billet/billet-edit/forms/form-fees/form-fees';
import { FormFine } from './billet/billet-edit/forms/form-fine/form-fine';
import { FormProtest } from './billet/billet-edit/forms/form-protest/form-protest';
import { FormDiscount } from './billet/billet-edit/forms/form-discount/form-discount';
import { FormPayer } from './billet/billet-edit/forms/form-payer/form-payer';
import { ChargingRoutingModule } from './charging-routing.module';
import { FavoritesModule } from './favorites/favorites.module';
import { CharginBilletList } from './billet/billet-list/billet-list.page';
import { CharginBilletLotEmitDetailed } from './billet/lot-emit-detailed/lot-emit-detailed.page';
import { CharginBilletLotViewDetail } from './billet/billet-lot-view-detail/billet-lot-view-detail.page';
import { CharginBilletEmitIndividual } from './billet/billet-emit-individual/billet-emit-individual.page';
import { FormDocument } from './billet/billet-edit/forms/form-document/form-document';
import { CharginBilletManagementPage } from './billet/billet-management/billet-management.page';
import { FormAbatement } from './billet/billet-edit/forms/form-abatement/form-abatement';
import { BillingModule } from '../../cash-in/billing/billing.module';
import { UiCPaginatorModule } from '@wlp/ui-c-paginator';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ComponentsModule,
        ReactiveFormsModule,
        NgxMaskIonicModule.forRoot(),
        UiCAccountBalanceModule,
        UiBsCashInModule.forRoot({device: 'WEB', config: environment}),
        BrMaskerModule,
        UiCTransferValueModule,
        UiCOtherAccountModule,
        UiCAsideMenuLeftModule,
        RouterModule,
        UiCInfoCardModule,
        UiCCardInfoModule,
        UiBsTranslateModule.forRoot({device: 'WEB', config: environment}),
        UiCNotificationsModule,
        UiBsCashOutModule.forRoot({device: 'WEB', config: environment}),
        UiCDatePickerModule.forRoot({environment: 'web'}),
        UiCModalModule,
        HeaderUserInfoModule,
        UiCTransferReceiptModule,
        ModalsModule,
        ChargingRoutingModule,
        FavoritesModule,
        UiCEmitBilletChargingModule,
        UiCEmitBilletChargingV1Module,
        UiCFavoritesListModule,
        UiCPersonalAddressModule,
        FormsModule,
        UiCPersonalAddressV2Module,
        UiCInputModule,
        UiCPaginatorModule.forRoot({device: 'WEB', config: environment}),
        BillingModule,
    ],
    declarations: [BilletInfo, CharginBilletManagementPage, CharginBilletCreatePage, CharginBilletEmitPage, CharginBilletDetailedPage, CharginBilletList, CharginBilletEmitConfirmation, CharginBilletViewDetail, CharginBilletEdit, CharginBilletLotEmitDetailed, CharginBilletLotViewDetail, CharginBilletEmitIndividual, FormDiscount, FormDueDate, FormDeadlinePayment, FormDocument, FormFees, FormFine, FormNominalValue, FormEmitBilletDetails, FormPayer, FormProtest, FormAbatement],
    entryComponents: [ModalTransferOnUsComponent, ModalFavoriteTypeComponent],
    providers: [
        InterceptService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptService,
            multi: true,
        },
    ],
    bootstrap: [],
})
export class ChargingModule { }
